import React, { createContext, useContext, useState, useCallback } from 'react';

export interface VerifyEmailModalContextValue {
  open: boolean;
  setOpen: (open: boolean) => void;
  openModal: () => void;
}

const defaultValue: VerifyEmailModalContextValue = {
  open: false,
  setOpen: () => {},
  openModal: () => {},
};

const VerifyEmailModalContext = createContext<VerifyEmailModalContextValue>(defaultValue);

export function VerifyEmailModalProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const openModal = useCallback(() => setOpen(true), []);
  const value = React.useMemo(() => ({ open, setOpen, openModal }), [open, openModal]);
  return (
    <VerifyEmailModalContext.Provider value={value}>
      {children}
    </VerifyEmailModalContext.Provider>
  );
}

export function useVerifyEmailModal(): VerifyEmailModalContextValue {
  return useContext(VerifyEmailModalContext);
}
